import { useState, useEffect, useMemo } from 'react';
import { fetchFollowingGroups } from '@/pages/intelligence/services/following';
import { getLocale } from 'umi';
import { MANAGER_GROUP_NAME } from '@/pages/intelligence/pages/Following/_config/constant';

const useFollowingGroupFilter = (props: {
  entityType: string;
  DEFAULT_GROUPNAME: string;
}) => {
  const { entityType, DEFAULT_GROUPNAME } = props;
  const locale = getLocale();
  const [groupOptions, setGroupOptions] = useState<any[]>([]);
  const [updateGroupList, setUpdateGroupList] = useState(false);
  useEffect(() => {
    getGouptFilterList({
      entity_type: entityType,
      hasAllGames: true, //区分旧风格，
    });
  }, [entityType]);

  useEffect(()=> {
    if(updateGroupList){
      getGouptFilterList({
        entity_type: entityType,
        hasAllGames: true, //区分旧风格，
      });
    }
  }, [updateGroupList])

  const getGouptFilterList = async (params: any) => {
    try {
      const res = await fetchFollowingGroups(params);
      const groupList = res?.data?.group_lists;
      setGroupOptions(groupList);
      setUpdateGroupList(false);
    } catch (err) {
      setGroupOptions([
        {
          entity_name: DEFAULT_GROUPNAME,
          game_list_total: 0,
        },
      ]);
      setUpdateGroupList(false);
    }
  };

  const getAllGameGroupText = (value: string, entityType: string) => {
    const nameMap = {
      'All Games': entityType == 'company' ? MANAGER_GROUP_NAME.allcompanies : MANAGER_GROUP_NAME.allgames,
      'My favourite': MANAGER_GROUP_NAME.myfavourite
    } as any;
    return nameMap[value];
  };

  const newGroupOpions = useMemo(() => {
    if (!Array.isArray(groupOptions)) {
      return []
    }
    const groupList = groupOptions?.map((item: any) => {
      const value = item?.entity_name;
      const textObj = getAllGameGroupText(item?.entity_name, entityType);
      const text = (locale === 'zh-CN' ? textObj?.textcn : textObj?.text) || value;
      return {
        value: item?.entity_name,
        text: `${text} (${item?.game_list_total})`,

      };
    });
    return groupList
  }, [locale, groupOptions])

  return {
    groupOptions: newGroupOpions,
    setUpdateGroupList
  };
};

export default useFollowingGroupFilter;
